module.exports = {
  light: {
    primary: "#189EBC",
    secondary: "#023047",
    accent: "#FA8503",
    error: "#FA8503",
    info: "#189EBC",
    success: "#16AF8E",
    warning: "#FB8C00",
    proibido: "#FA8503",
    evitar: "#607D8B",
    fixa: "#023047",
    ajuste: "#189EBC",
    favorito: "#FBC02D",
    verificado: "#16AF8E",
    fundo: "#FAF6EC",
  },
  dark: {
    primary: "#189EBC",
    secondary: "#023047",
    accent: "#FA8503",
    error: "#FA8503",
    info: "#189EBC",
    success: "#16AF8E",
    warning: "#FB8C00",
    proibido: "#FA8503",
    evitar: "#607D8B",
    fixa: "#3D6E9E",
    ajuste: "#189EBC",
    favorito: "#FFD54F",
    verificado: "#16AF8E",
    fundo: "#121212",
  },
};
